import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router';

import appSelectors from '@/redux/app/appSelectors';

import { setLanguage, setRefCode } from '@/redux/app/appSlice';

import useWindowSize from '@/hooks/useWindowSize';
import useWindowScrollY from '@/hooks/useWindowScrollY';
import useBlockScroll from '@/hooks/useBlockScroll';
import useTranslation from '@/hooks/useTranslation';

import Router from '@/router';

import LoaderSpinner from '@/components/loaderSpinner';

function App() {
  const dispatch = useDispatch();

  const displayLoader = useSelector(appSelectors.displayLoader);

  const [searchParams, setSearchParams] = useSearchParams();

  const language = searchParams.get('lang');
  const refCode = searchParams.get('ref');

  useWindowSize();
  useWindowScrollY();
  // Запрет скролла при открытии меню/модалки
  useBlockScroll();
  useTranslation();

  useEffect(() => {
    if (!language || !refCode) return;

    if (language) dispatch(setLanguage(language.toLowerCase()));
    if (refCode) dispatch(setRefCode(refCode));

    setSearchParams({});
  }, [dispatch, language, refCode, setSearchParams]);

  return (
    <>
      <Router />
      {displayLoader && <LoaderSpinner />}
    </>
  );
}

export default App;
